import { Checkbox } from '@mui/material';
import { StyledTitle } from '@/components/MobileApproval/Body/MyReferrer/styles';
import React from 'react';

type P = {
  checked: boolean;
  onClick(): void;
  title: string;
};

const CheckBox = ({ checked, onClick, title }: P) => {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        padding: '16px 0 0 0',
      }}
    >
      <Checkbox
        checked={checked}
        onChange={onClick}
        sx={{
          '& .MuiSvgIcon-root': { fontSize: 23 },
          color: 'var(--dk-text-dim, #B7BBC2)',
          '&.Mui-checked': {
            color: 'var(--dk-text, black)',
          },
        }}
      />
      <StyledTitle onClick={onClick}>{title}</StyledTitle>
    </div>
  );
};
export default CheckBox;
